import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  CHANGE_USER_EMAIL_SUCCESS,
  CHANGE_USER_EMAIL_FAILURE,
  SET_CHANGE_USER_EMAIL_LOADING,
  RESET_CHANGE_USER_EMAIL_STATE,
  CHANGE_USER_EMAIL_LOG_SET_SHOWN,
  CHANGE_USER_EMAIL_LOG_SET_DATA,
  CHANGE_USER_EMAIL_LOG_SET_IS_LOADING,
  CHANGE_USER_EMAIL_LOG_SET_ERRORS,
} from 'state/actionTypes';

const initialState = {
  isLoading: false,
  success: false,
  error: null,
};

const changeUserEmailSuccess = state => ({
  ...state,
  isLoading: false,
  success: true,
  error: null,
});

const changeUserEmailFailure = (state, action) => ({
  ...state,
  isLoading: false,
  success: false,
  error: action.payload,
});

const setChangeUserEmailLoading = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const resetChangeUserEmailState = () => ({
  ...initialState,
});

const main = createReducer(initialState, {
  [CHANGE_USER_EMAIL_SUCCESS]: changeUserEmailSuccess,
  [CHANGE_USER_EMAIL_FAILURE]: changeUserEmailFailure,
  [SET_CHANGE_USER_EMAIL_LOADING]: setChangeUserEmailLoading,
  [RESET_CHANGE_USER_EMAIL_STATE]: resetChangeUserEmailState,
});

const logModalInitialState = {
  shown: false,
  isLoading: false,
  data: [],
  paging: {
    page: 1,
    size: 20,
    total: 0,
  },
  errors: [],
};

const log = createReducer(logModalInitialState, {
  [CHANGE_USER_EMAIL_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.shown = payload.shown;
  },
  [CHANGE_USER_EMAIL_LOG_SET_DATA]: (draft, { payload }) => {
    draft.data = payload.data;
    draft.paging = payload.paging;
  },
  [CHANGE_USER_EMAIL_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [CHANGE_USER_EMAIL_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.errors = payload.errors;
  },
});

export default combineReducers({
  main,
  log,
});
